<template>

<DialogBox :settings="settings" :disabled="!isFormValid" @save="save">
    <div class="pa-3">
        <span style="color:grey">{{settings.path}}</span>
        <vue-html5-editor :content="element.value || ''" :auto-height="true" @change="htmlChanged"></vue-html5-editor>
    </div>
</DialogBox>

</template>

<script>
import DialogBox from '../ui-elements/DialogBox'

export default {
props:{
    settings: Object,
    element: Object,
},
components:{
    'DialogBox': DialogBox
},
data() {
    return {

    }
},
computed: {

    transaction() {
        return this.$store.getters.transaction
    },
    

    isFormValid() {
        return true
    }

    
},
methods: {

    htmlChanged(str) {
        this.element.value = str
    },

    save() {
        this.$emit('save', this.element)
    },

},

}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// LookupDialog.vue?1d9f505e